import * as React from 'react';

/**
 * @todo move from deprecated typography to new one
 * @see {@link https://jira.cian.tech/browse/CD-163108}
 */
import { Header0, ArticleHeading2, UIText1 } from '@cian/ui-kit/typography';
import { ConditionalWrapper } from '@cian/conditional-component';
import { useIsDesktop } from '@cian/valuation-utils-component';

import { RealtorCard } from './components/RealtorCard/RealtorCard';
import { CardAvatarContainer } from '../../containers/CardAvatarContainer';
import { ISpecialistCatalogListingSchema } from '../../../node/repositories/demand/entities/specialist_catalog/SpecialistCatalogListingSchema';

import * as styles from './styles.css';

export interface IQuizCompletedProps {
  backToPage: React.ReactElement;
  realtors: ISpecialistCatalogListingSchema[];
  title: string;
  subtitle: string;
  description?: string;
  footer?: React.ReactElement;
}

export const QuizPersonalApplication: React.FC<React.PropsWithChildren<IQuizCompletedProps>> = props => {
  const { backToPage, title, subtitle, description, footer, realtors } = props;
  const isDesktop = useIsDesktop();

  return (
    <div className={styles['wrapper']} data-testid="success">
      {isDesktop && <div className={styles['header']}>{backToPage}</div>}
      <div className={styles['container']}>
        <div className={styles['title']}>
          <ConditionalWrapper if={isDesktop} ThenComponent={Header0} ElseComponent={ArticleHeading2}>
            {title}
          </ConditionalWrapper>
        </div>
        <div className={styles['text']}>
          <UIText1 color="current_color">{subtitle}</UIText1>
        </div>
        {description && (
          <div className={styles['description']}>
            <UIText1 color="current_color">{description}</UIText1>
          </div>
        )}
        <div className={styles['cards']}>
          {realtors.map(({ fullName, id, trustLevelName, trustLevel, timeOnSite, agencyName, avatarUrl }) => (
            <RealtorCard
              key={id}
              previewImg={<CardAvatarContainer imgUrl={avatarUrl} fullName={fullName} isCircleImage={true} />}
              hasRgrParticipation={false}
              name={fullName}
              levelName={trustLevelName}
              levelNumber={trustLevel}
              timeOnSite={timeOnSite}
              agencyName={agencyName}
            />
          ))}
        </div>
        {footer && (
          <div className={styles['footer']} data-testid="footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

QuizPersonalApplication.displayName = 'QuizPersonalApplication';
